import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { getGuides } from './getGuides';

export default function* watchGuides() {
    yield all([takeLatest(actionTypes.FETCH_GUIDES, getGuides)]);
}
